export default __webpack_public_path__ + "static/anzeige-mwb-makler-dd3492af4e8bcfa669f72d064f5adfdb.jpg";